import { render, staticRenderFns } from "./first-scene.vue?vue&type=template&id=eb15628e&"
import script from "./first-scene.vue?vue&type=script&lang=js&"
export * from "./first-scene.vue?vue&type=script&lang=js&"
import style0 from "./first-scene.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports